import { useCallback, useEffect } from "react";
import VoiceUtils from "../../../utils/VoiceUtils";

/**
 * Hook que anuncia textos por voz sin que un fallo de síntesis rompa la pantalla
 * y vacía la cola de locución pendiente al desmontar.
 * @returns {{ anunciar: (texto: string) => void }} Función estable para locutar
 */
export const useVozTurnos = () => {
    const anunciar = useCallback((texto) => {
        if (typeof texto !== "string" || !texto) return;
        try {
            VoiceUtils.speak(texto);
        } catch (err) {
            console.warn("No se pudo reproducir la voz:", err);
        }
    }, []);

    useEffect(() => () => {
        const sintesis = typeof window !== "undefined" ? window.speechSynthesis : undefined;
        if (typeof sintesis?.cancel === "function") sintesis.cancel();
    }, []);

    return { anunciar };
};
